import type { IconData } from '@stacksjs/iconify-core'

export const smileyDroolRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.75 24C4.75 13.369 13.369 4.75 24 4.75S43.25 13.369 43.25 24S34.632 43.25 24 43.25S4.75 34.632 4.75 24M24 .75C11.16.75.75 11.16.75 24S11.16 47.25 24 47.25S47.25 36.84 47.25 24S36.84.75 24 .75M13.405 19.683c.417-1.47 2.133-2.542 3.982-2.074a2.5 2.5 0 0 0 1.226-4.848c-4.25-1.074-8.802 1.27-10.018 5.556a2.5 2.5 0 1 0 4.81 1.366m21.19 0c-.417-1.47-2.134-2.542-3.982-2.074a2.5 2.5 0 1 1-1.226-4.848c4.25-1.074 8.8 1.27 10.018 5.556a2.5 2.5 0 1 1-4.81 1.366m-3.596 15.065l.011-.008A2.5 2.5 0 0 0 36 34.5V27a2 2 0 0 0-2-2H13.997c-1.105 0-2.015.902-1.833 1.992C13.112 32.672 18.05 37 23.999 37q.505 0 1-.041v.04a3 3 0 1 0 6 0z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default smileyDroolRemix
